import './styles.css';
import 'pixi.js'
import 'pixi-sound';
import { Game } from './game';

const template = new Game();
template.run();